import { useDispatch, useSelector } from 'react-redux';
import styles from '../../../styles/components/mechanicButton.module.scss';
import { translations } from '../../../utils/translations';
import { setFilter } from '../store/actions';

const MechanicButton = ({mobilityTypes}) => {
    const dispatch = useDispatch();
    const appSettings = useSelector(({ rootReducer }) => rootReducer.baseSettings);
    const lang = appSettings.searchLanguage ? appSettings.searchLanguage : "en";
    const translate = (s) => translations[lang][s] || s;

    const excludedMobilityTypes = ['fietsen', 'hulpmiddelen'];
    mobilityTypes = mobilityTypes?.filter((mobilityType) => !excludedMobilityTypes.includes(mobilityType.value));

    const urlParams = mobilityTypes && `${mobilityTypes.map((mobilityType) => mobilityType.value).reduce((a, b) => `${a}&recruitee_mobility_type=${b}`, "")}`;

    const onClick = () => {
        dispatch(setFilter(`page=1&recruitee_role=monteur${urlParams}`, true));
    };

    return (
        <button className={styles.mechanicButton} onClick={onClick} aria-label={"Bekijk onze monteur vacatures"}>
            <img src={"/app/plugins/louwman-job-search/public/images/monteur-vacatures.png"}
                alt={translate("mechanic_button_alt")} />
        </button>
    );
};

export default MechanicButton;
